import React, {ReactNode} from "react";
import {AIProvider, AIProviderSettingsProps} from "../AIProvider";
import {GrokSettings} from "./GrokSettings";

export class GrokProvider implements AIProvider {
    priority = 4
    name = 'Grok'
    icon = <svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" width="20px" height="20px"
                textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd"
                clipRule="evenodd" viewBox="0 0 512 509.641">
        <path fill="#000"
              d="M339.693 401.216V198.432l48.293-68.967v271.751h-48.293zm-215.62-189.305L256.627 401.22h58.918l-132.56-189.309h-58.912zm-.059 189.309l58.93-84.166 29.48 42.103-29.457 42.063h-58.953zm205.001-292.8L227.143 253.915l29.475 42.094L387.973 108.42h-58.958z"/>
    </svg>
    settingComponent = (props: AIProviderSettingsProps) => <GrokSettings settings={props.settings} onChange={props.onChange} provider={this}/>
    models = [
        'grok-2-1212',
        'grok-2-vision-1212',
    ]
}